import React, { PropsWithChildren, useContext, useEffect, useState } from 'react';
import { ApiContext } from '@api/api';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { Clickable, Col } from '@components/styles';
import { InputText } from 'primereact/inputtext';
import { SelectButton } from 'primereact/selectbutton';

interface Props {
  value: string[];
  onChange: (v: string[]) => void;
}

export const EnableFeature: React.FC<Props> = ({ value, onChange }) => {
  const { adminLovAllFeatures } = useContext(ApiContext);
  const [options, setOptions] = useState<string[]>();

  useEffect(() => {
    adminLovAllFeatures(d => {
      setOptions(d);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SelectButton multiple={true} value={value} options={options} onChange={e => onChange(e.value)} />
    </>
  );
};

interface NullableInputProps {
  value: unknown;
  onChange: (v: unknown) => void;
  defaultValue: unknown;
}

export const NullableInput: React.FC<PropsWithChildren<NullableInputProps>> = ({ children, value, onChange, defaultValue }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      {value !== null ? (
        <Col className={'w-full'}>
          {children}
          <div>
            <Clickable onClick={() => onChange(null)}>{tr('adminCompanyDetail.setNull', 'Set null')}</Clickable>
          </div>
        </Col>
      ) : (
        <Col className={'w-full'}>
          {tr(`HorizontalFieldValue.undefined`, `Value not set`)}
          <div>
            <Clickable onClick={() => onChange(defaultValue)}>{tr('adminCompanyDetail.setValue', 'Set value')}</Clickable>
          </div>
        </Col>
      )}
    </>
  );
};

const sanitizePrefix = (v: string) => v.toUpperCase().replace(/[^A-Z]/g, '');

interface PrefixInputProps {
  label: string;
  value?: string | null;
  onChange: (v: string) => void;
}

export const PrefixInput: React.FC<PrefixInputProps> = ({ label, value, onChange }) => {
  return (
    <div className={'flex flex-col gap-1'}>
      <span className={'text-sm text-content-secondary'}>{label}</span>
      <InputText className={'w-[160px]'} value={value ?? ''} onChange={e => onChange(sanitizePrefix(e.target.value))} />
    </div>
  );
};
